export default __webpack_public_path__ + "static/media/hero-video-mobile-safari-en.568cee8e.mp4";